export const onCreateOrderSubscription = `
subscription MySubscription ($hotelId: String!){
  onCreateOrder(hotelId: $hotelId){
  completedTime
  createdAt
  delayReason
  deliveryLocation
  guestName
  hotelId
  id
  createdBy
  noOfItems
  items {
  addOns {
  name
  price
  code
  }
  amount
  code
  cookingInstructions
  count
  name
  customisations {
  code
  name
  }
  }
  paymentMethod
  pk
  roomNo
  sk
  startTime
  status
  totalAmount
  updatedAt
  updatedBy
  version
  }
  }
`;
export const onCreateSpaOrderSubscription = `
subscription MySubscription ($hotelId: String!, $spaId: String!){
  onCreateSpaOrder(hotelId: $hotelId, spaId: $spaId){
    bookingTime
    createdAt
    createdBy
    guestName
    guestType
    hotelId
    id
    spaId
    items {
      description
      amount
      name
      treatmentDuration
      specialRequest
    }
    numberOfGuest
    pk
    pax
    scheduledDate
    scheduledTime
    sk
    totalAmount
    status
    treatmentDuration
    updatedAt
    updatedBy
    version
  }
}
`;

export const onCreateFnBOrderSubscription = `
subscription MySubscription ($hotelId: String!, $restaurantId: String!){
  onCreateFAndBOrder(hotelId: $hotelId, restaurantId:$restaurantId){
    completedTime
    guestName
    guestType
    hotelId
    id
    items {
      addons {
        code
        name
        price
      }
      amount
      code
      cookingInstructions
      count
      customisations {
        code
        name
      }
      name
    }
    lang
    noOfGuests
    noOfItems
    pk
    restaurantId
    sk
    startTime
    status
    tableNumber
    phoneNumber
    roomNumber
    paymentMethod
  }
}
`;

export const onCreateRestaurantTableSubscription = `
subscription MySubscription($hotelId: String!, $restaurantId: String!) {
  onCreateRestaurantReservation(hotelId: $hotelId, restaurantId:$restaurantId) {
    bookingDate
    date
    exposure
    firstName
    hotelId
    id
    isReservedForGuest
    lastName
    noOfGuests
    reserveFrom
    reserveUntil
    restaurantId
    roomNo
    status
    tableNumbers
  }
}
`;

export const onCreateFnBBillSubscription = `
subscription MySubscription($hotelId: String!, $restaurantId: String!) {
  onRequestFAndBBill (hotelId: $hotelId, restaurantId:$restaurantId){
    completedTime
    guestName
    guestType
    hotelId
    id
    lang
    noOfGuests
    noOfItems
    orders {
      id
      items {
        addons {
          code
          name
          price
        }
        amount
        code
        cookingInstructions
        count
        customisations {
          code
          name
        }
        image
        name
      }
    }
    pk
    restaurantId
    sk
    startTime
    status
    tableNumber
  }
}
`;

export const onCreateHousekeepingOrderSubscription = `
subscription MySubscription {
  onCreateHouseKeepingOrder {
    bookingId
    bookingTime
    createdAt
    createdBy
    guestName
    hotelId
    id
    lang
    pk
    requestType
    resolvedTime
    roomNo
    serviceName
    sk
    status
    updatedAt
    updatedBy
    version
  }
}
`;
